export function login (state, auth) {
  state.auth = auth
}

export function logout (state) {
  state.auth = undefined
  state.privileges = []
}

export function loadAreas (state, areas) {
  state.areas = areas
}

export function loadShops (state, shops) {
  state.shops = shops
}

export function loadPermissions (state, permissions) {
  state.permissions = permissions
}

export function loadPlainPermissions (state, permissions) {
  state.plainPermissions = permissions
}

export function loadUiPrivilege (state, privileges) {
  state.privileges = privileges || []
}

export function setUiPrivilegeLoaded (state) {
  state.privilegeLoaded = true
}

export function loadOrderBrands (state, brands) {
  state.orderBrands = brands
}

export function UpdateNewAdd (state, val) {
  state.newAdd = val
}

export function SelectArea (state, val) {
  state.area = val
}

export function loadStAreas (state, val) {
  val.sort((a, b) => a.localeCompare(b))
  state.stAreas = val
}

export function loadSubSellers (state, val) {
  val.sort((a, b) => a.name.localeCompare(b.name))
  state.subSellers = val
}
